import { commaListSchema, filterDateRangeSchema } from "@birdwatch/common";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { MemberActivationReport } from "@/features/office/reports/member-activation";
import {
  filterSearchFragment,
  notificationSearchFragment,
  withOperators,
} from "@/features/shared/filters-new";
import { maskSearchFragment } from "@/features/shared/route-masking";

// Lenient URL schema (strict enums on URL params crash the page — see
// webapp-routing.md). Filter state follows the shared `filters-new` chip DSL:
// a `filters` object + `filtersOrder`. `health` and `milestone` stay top-level
// params owned by the pool tiles / milestone cards (not chips), and `sort` is
// the canonical `sort=-field` string driven by the table headers.
const searchSchema = z.object({
  search: z.string().optional().catch(undefined),
  sort: z.string().optional().catch(undefined),
  health: z.string().optional().catch(undefined),
  milestone: z.string().optional().catch(undefined),
  filters: z
    .object({
      // singleSelect chips store a SCALAR (cf. the orders lists' `priority`)
      // — commaListSchema here would coerce it to an array the widget can
      // never match against its own options.
      stage: withOperators(z.string().optional()),
      market: withOperators(commaListSchema),
      plan: withOperators(commaListSchema),
      // The standard date-range chip value ({ start, end, label }). The
      // .catch matters here specifically: this key USED to be a month comma
      // list, so bookmarked URLs carry a string the object schema rejects —
      // degrade to "no filter", never to the error boundary.
      joined: filterDateRangeSchema.catch(undefined),
      ...notificationSearchFragment,
    })
    .optional(),
  ...filterSearchFragment,
  ...maskSearchFragment,
});

export const routeId = "/office/reports/member-activation";
export const Route = createFileRoute("/office/reports/member-activation")({
  validateSearch: searchSchema,
  component: MemberActivationReport,
});
